import { useAuthStore } from '@/store/auth'
import { useConfigStore } from '@/store/config'
import { useKitchenOrderStore } from '@/store/kitchenOrders'
import type { KitchenOrder, KitchenOrderVersion, Tab } from '@/types'
import { playSound } from '@/utils/sound'

const events = {
  kitchenNoteAdded(_: { courseLabel: string; tab: Tab }, _local: boolean) {
    // TODO
  },

  kitchenOrderAdded({ order }: { tabId: string; order: KitchenOrder }, _local: boolean) {
    const tabs = useKitchenOrderStore()
    tabs.kitchenOrders[order.id] = order
    playSound('new')
  },

  kitchenOrderVersionAdded(
    {
      orderId,
      version
    }: {
      orderId: string
      version: KitchenOrderVersion
    },
    _local: boolean
  ) {
    const tabs = useKitchenOrderStore()
    if (tabs.kitchenOrders[orderId]) {
      tabs.kitchenOrders[orderId].versions.push(version)
      playSound('new-version')
    }
  },

  kitchenOrderStatusUpdated(
    {
      orderId,
      status
    }: {
      orderId: string
      status: KitchenOrder['status']
    },
    _local: boolean
  ) {
    const tabs = useKitchenOrderStore()
    if (tabs.kitchenOrders[orderId]) {
      tabs.kitchenOrders[orderId].status = status
    }
  },

  kitchenProductStatusUpdated(
    {
      orderId,
      productId,
      status
    }: {
      orderId: string
      productId: string
      status: 'pending' | 'ongoing' | 'completed' | 'cancelled' | null
    },
    _local: boolean
  ) {
    const tabs = useKitchenOrderStore()
    const order = tabs.kitchenOrders[orderId]
    if (!order) return
    for (const version of order.versions) {
      for (const product of version.products) {
        if (product.id === productId) {
          product.status = status
        }
      }
    }
  },

  deviceDeleted({ deviceId }: { deviceId: string }, _local: boolean) {
    const auth = useAuthStore()
    const config = useConfigStore()
    if (config.device.id === deviceId) {
      auth.logout()
    }
  }
}

export default events
